module.exports = __webpack_public_path__ + "static/media/vehicles-icon.4caa5e64.svg";